import Modal from "react-bootstrap/Modal";
import API from "services/axios";
import authHeader from "services/auth-header";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setNotification } from "features/Notification/notificationSlice";
import { useNavigate } from "react-router-dom";

function LeadAdd({ leadsData, showAddModal, setShowAddModal }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  /*   ALL STATES
   ********************************************* */
  const { handleSubmit } = useForm();
  const [leadName, setLeadName] = useState("");
  const [companyError, setCompanyError] = useState(null);
  const [searchResults, setSearchResults] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);

  const [loading, setLoading] = useState(false);

  /*   ALL FUNCTIONS
   ********************************************* */
  const addLead = async (formData, e) => {
    e.preventDefault();
    if (companyError) {
      dispatch(
        setNotification({
          message: companyError,
          type: "error",
        })
      );
      return;
    }
    if (leadName === "") {
      dispatch(
        setNotification({
          message: "Please enter a lead name",
          type: "error",
        })
      );
      return;
    }
    setLoading(true);

    try {
      const { data } = await API.post(
        "/leads/add",
        {
          data: {
            leadName: leadName,
          },
        },
        { headers: authHeader() }
      );
      if (data.success) {
        setLeadName("");
        setShowAddModal(false);
        setLoading(false);
        navigate("/lead/details/" + data.leadId);
        return;
      }
      setLoading(false);
    } catch (err) {
      alert(err.message);
      setLoading(false);
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    }
  };

  // Search for lead name via API
  useEffect(() => {
    if (!leadName) {
      setSearchResults([]);
      setCompanyError("");
      return;
    }
    setSearchLoading(true);
    const timer = setTimeout(async () => {
      try {
        const body = {
          page: 1,
          limit: 10,
          query: leadName,
          searchFields: ["leadName"],
        };
        const { data } = await API.post("/leads/search-pagination", body, {
          headers: authHeader(),
        });
        if (data?.success) {
          setSearchResults(data?.workOrders || []);
          // Check for exact duplicate
          const duplicate = (data?.workOrders || []).find(
            (item) => item.leadName?.toLowerCase() === leadName.toLowerCase()
          );
          setCompanyError(duplicate ? `${leadName} already exists` : "");
        } else {
          setSearchResults([]);
          setCompanyError("");
        }
      } catch (err) {
        setSearchResults([]);
        setCompanyError("");
      } finally {
        setSearchLoading(false);
      }
    }, 300);
    return () => clearTimeout(timer);
  }, [leadName]);

  return (
    <Modal show={showAddModal} onHide={() => setShowAddModal(false)}>
      <Modal.Body>
        <div className="d-flex justify-content-center flex-column px-2">
          <h3> Add Lead </h3>
          <hr className="mb-3 mt-1" />
          <form onSubmit={handleSubmit(addLead)}>
            {/* Lead Name */}
            <div className="">
              <label className="form-label mb-0">Lead Name</label>
              <input
                placeholder="Enter company name"
                onChange={(e) => setLeadName(e.target.value)}
                value={leadName}
                type="text"
                required
                className="form-control"
              />
              <p className="text-danger fs-6">{companyError}</p>
            </div>
            {leadName && (
              <div
                className="bg-white px-2 shadow-lg scroll py-2"
                style={{
                  maxHeight: "50%",
                  scrollBehavior: "auto",
                  borderRadius: 10,
                }}
              >
                {searchLoading && (
                  <div className="px-2 py-2 text-muted d-flex align-items-center">
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Searching...
                  </div>
                )}
                {!searchLoading &&
                  searchResults.length > 0 &&
                  searchResults.map((item, idx) => (
                    <div key={item.id} className="">
                      <div
                        className={`px-2 rounded py-1 ${
                          item.leadName.toLocaleLowerCase() ===
                          leadName.toLocaleLowerCase()
                            ? "bg-primary bg-opacity-25"
                            : ""
                        }`}
                      >
                        {item?.leadName}
                      </div>
                      {idx < searchResults.length - 1 && (
                        <hr className="my-0 " />
                      )}
                    </div>
                  ))}
                {!searchLoading && searchResults.length === 0 && (
                  <div className="px-2 py-2 text-muted">No results</div>
                )}
              </div>
            )}

            {/*   Buttons
             ********************************************* */}
            <div className="d-flex justify-content-end align-items-end flex-grow-1 mt-3">
              <div>
                <button
                  type="button"
                  className="btn btn-secondary me-1"
                  onClick={() => setShowAddModal(false)}
                >
                  CLOSE
                </button>

                <button
                  disabled={loading || companyError}
                  type="submit"
                  className="btn btn-primary"
                >
                  Add
                </button>
              </div>
            </div>
          </form>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default LeadAdd;
